<mat-card>
    <mat-card-header>

        @if (isVevo) {
        <mat-card-title>Details</mat-card-title>
        }
        @else {
        <mat-card-title>Employer Details</mat-card-title>
        }

    </mat-card-header>

    <mat-card-content class="m-t-1">

        <app-text-input label="Business/Organisation Name"
            [control]="employerSponsorForm.controls.name" shortLabel="Business Name"></app-text-input>
        <app-text-input label="Australian Business Number (ABN)"
            [control]="employerSponsorForm.controls.abn" shortLabel="ABN"></app-text-input>

        <div class="question-container"> 
            <label>{{ personTerm() }}</label>
            <app-text-input [control]="employerSponsorForm.controls.firstName" label="First Name"></app-text-input>
            <app-text-input [control]="employerSponsorForm.controls.surname" label="Surname"></app-text-input>
            <app-text-input [control]="employerSponsorForm.controls.email" label="Email"></app-text-input>
            @if(!isVevo){
            <app-phone-input label="Best contact phone number"
                [phoneTypes]="phoneTypes"
                [phoneTypeControl]="employerSponsorForm.controls.phoneType"
                [phoneCountryCodeControl]="employerSponsorForm.controls.phoneCountryCode"
                [phoneAreaCodeControl]="employerSponsorForm.controls.phoneAreaCode"
                [phoneNumberControl]="employerSponsorForm.controls.phoneNumber">
            </app-phone-input>
            }
        </div>


        <app-address label="What is the physical address of the business?"
            [addressForm]="employerSponsorForm.controls.businessAddress" shortLabel="Business Address">
        </app-address>   
        @if(!isVevo){

        <app-date-input label="When did this business start trading"
            [control]="employerSponsorForm.controls.startTrading" shortLabel="Start Trading"></app-date-input>
            
            <app-text-input label="How many full time Australian staff does the business currently employ?"
            [control]="employerSponsorForm.controls.ausStaff" type="number" shortLabel="Full Time Staff" [errorMsg]="'Numbers Only'"></app-text-input>
            
            <app-radio-input label="Has the business invested in training its Australian staff?"
            [control]="employerSponsorForm.controls.investedTraining" shortLabel="Invested in Training"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
        </app-radio-input>
        }

    </mat-card-content>
</mat-card>